import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=39ad9905&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=39ad9905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad9905",
  null
  
)

export default component.exports